export const ROLE_LABELS = {
  admin: "Administrador",
  sup: "Supervisor",
  usuario: "Usuario",
};

// Default fallback statuses (used only if catalog fails to load).
export const DEFAULT_STATUS_OPTIONS = ["Pendiente", "En Proceso", "Completada", "Cancelada"];

// Known status variants. Unknown statuses fall back to a neutral style.
export const STATUS_VARIANT = {
  Pendiente: "bg-[hsl(var(--status-pending)/0.18)] text-[hsl(var(--status-pending))] border border-[hsl(var(--status-pending)/0.35)]",
  "En Proceso": "bg-[hsl(var(--status-in-progress)/0.18)] text-[hsl(var(--status-in-progress))] border border-[hsl(var(--status-in-progress)/0.35)]",
  Completada: "bg-[hsl(var(--status-completed)/0.18)] text-[hsl(var(--status-completed))] border border-[hsl(var(--status-completed)/0.35)]",
  Cancelada: "bg-[hsl(var(--status-cancelled)/0.18)] text-[hsl(var(--status-cancelled))] border border-[hsl(var(--status-cancelled)/0.35)]",
};

// Evidencia status: fallback + visual variants
export const DEFAULT_EVIDENCIA_STATUS_OPTIONS = [
  "Pendiente de subir",
  "Subida parcial",
  "Subida completa",
  "En revisión",
  "Aprobada",
  "Rechazada",
  "No requiere evidencia",
];

export const EVIDENCIA_STATUS_VARIANT = {
  "Pendiente de subir": "bg-[hsl(var(--status-pending)/0.18)] text-[hsl(var(--status-pending))] border border-[hsl(var(--status-pending)/0.40)]",
  "Subida parcial": "bg-amber-500/15 text-amber-300 border border-amber-500/40",
  "Subida completa": "bg-[hsl(var(--status-in-progress)/0.18)] text-[hsl(var(--status-in-progress))] border border-[hsl(var(--status-in-progress)/0.40)]",
  "En revisión": "bg-violet-500/15 text-violet-300 border border-violet-500/40",
  "Aprobada": "bg-[hsl(var(--status-completed)/0.18)] text-[hsl(var(--status-completed))] border border-[hsl(var(--status-completed)/0.40)]",
  "Rechazada": "bg-[hsl(var(--status-cancelled)/0.18)] text-[hsl(var(--status-cancelled))] border border-[hsl(var(--status-cancelled)/0.40)]",
  "No requiere evidencia": "bg-[hsl(var(--status-completed)/0.18)] text-[hsl(var(--status-completed))] border border-[hsl(var(--status-completed)/0.40)]",
};

// ESI (área que confirma la revisión + envío de reporte al cliente):
// fallback y variantes visuales.
export const DEFAULT_ESI_STATUS_OPTIONS = [
  "Pendiente revisión",
  "En revisión",
  "Reporte enviado al cliente",
  "Confirmado por cliente",
];

export const ESI_STATUS_VARIANT = {
  "Pendiente revisión": "bg-[hsl(var(--status-pending)/0.18)] text-[hsl(var(--status-pending))] border border-[hsl(var(--status-pending)/0.40)]",
  "En revisión": "bg-violet-500/15 text-violet-300 border border-violet-500/40",
  "Reporte enviado al cliente": "bg-[hsl(var(--status-in-progress)/0.18)] text-[hsl(var(--status-in-progress))] border border-[hsl(var(--status-in-progress)/0.40)]",
  "Confirmado por cliente": "bg-[hsl(var(--status-completed)/0.18)] text-[hsl(var(--status-completed))] border border-[hsl(var(--status-completed)/0.40)]",
  "Rechazado por cliente": "bg-[hsl(var(--status-cancelled)/0.18)] text-[hsl(var(--status-cancelled))] border border-[hsl(var(--status-cancelled)/0.40)]",
};

export const CATALOG_TYPES = [
  { key: "cliente", label: "Clientes" },
  { key: "solicitante", label: "Solicitantes" },
  { key: "tipo_trabajo", label: "Tipos de Trabajo" },
  { key: "puerto_entrada", label: "Puertos de Entrada" },
  { key: "estatus", label: "Estatus OT" },
  { key: "estatus_evidencia", label: "Estatus Evidencia" },
  { key: "estatus_esi", label: "Estatus ESI" },
  // NOTE: Clasificación B/C/D removed from the visible catalog tabs per user
  // request. They still exist in the backend so validations/dropdowns keep
  // working, but they are no longer manually editable from the UI.
];
